var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"production-progress__multiple-order-item"},[_c('span',[_vm._v(" "+_vm._s(_vm.order.name)+" ")]),_c('button',{on:{"click":_vm.removeOrder}},[_c('TrashIcon')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }